import { scrollToId } from '@/src/shared/lib'

export const feedbackFormModel = {
  srollToMe: () => {
    const firstField = document.getElementById('feedback-form')?.querySelector('input')

    scrollToId('feedback-form')
    firstField?.focus({ preventScroll: true })
  },
}
